/**
 * Types and format strings shared by the date module. Format strings use the Unicode tokens
 * date-fns reads (`yyyy`, `dd`, `d`), not moment's (`YYYY`, `DD`, `D`).
 */

export type DateInput = Date | string | number | null | undefined;

export type FormatPreset =
    | 'display' // dd/MM/yyyy (matches DISPLAY_DAY_FORMAT)
    | 'displayLong' // MMMM d, yyyy
    | 'displayWeek' // MMM d, yyyy
    | 'internal' // yyyy-MM-dd (for APIs)
    | 'datetime' // yyyy-MM-dd HH:mm:ss
    | 'time'; // HH:mm:ss

export type TimeUnit = 'day' | 'month' | 'year' | 'hour' | 'minute' | 'second';
export type PeriodUnit = 'hour' | 'day' | 'week' | 'month' | 'year';

export const DATE_FORMATS: Record<FormatPreset, string> = {
    display: 'dd/MM/yyyy',
    displayLong: 'MMMM d, yyyy',
    displayWeek: 'MMM d, yyyy',
    internal: 'yyyy-MM-dd',
    datetime: 'yyyy-MM-dd HH:mm:ss',
    time: 'HH:mm:ss',
} as const;

/**
 * The day the date inputs show and parse, and the day column of tables: the portal's one
 * display day (`formatDateDisplay` in `format.ts`), in every language.
 */
export const DISPLAY_DAY_FORMAT = DATE_FORMATS.display;
